import { Pencil, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import ComponentStatusIcon from "./ComponentStatusIcon";
import Button from "../../common/components/Button";
import { useCallback, useState } from "react";
import { useApp } from "../../common/contexts/AppContext";

function ListComponents({ components, action, setAction }) {
  const { isOwner } = useApp();
  return (
    <div className="mt-6">
      {components?.map((component, i) => {
        const { name, status, _id } = component;
        return (
          <div
            key={i}
            className="flex items-center justify-between p-6 rounded-md border border-gray-300 my-2"
          >
            <div>
              <div className=" text-lg">{name}</div>
              <div className="mt-3 flex items-center gap-2">
                <ComponentStatusIcon statusSlug={status?.slug} />
                {status?.label}
              </div>
            </div>
            {isOwner ? (
              <Link
                to={`/component-form/${_id}`}
                className="hover:bg-gray-100 rounded-md p-2 hover:text-blue-600 underline"
              >
                <Pencil size={20} />
              </Link>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}

export default ListComponents;
